/*
 *
 * Faqs constants
 *
 */

export const SELECT_FAQ = 'app/Faqs/SELECT_FAQ';
